import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { Avatar, Image, Row, Select, Space, Spin } from 'antd'

import {
    projectsList,
    projectsState,
    changePage as changeProjectPage,
} from '../../projects/projects.slice'
import { changePage, teamListGet, teamState } from '../../team/team.slice'
import {
    dateRangesList,
    projectReportsState,
} from '../../reports/projectReports/projectReports.slice'

import { CrossIcon } from '../../../assets/icons'
import DateFilter from './dateFilter'
import { getAllUserReportList, setDrawerFilter, setTableData } from '../store/finalReports.slice'
import InfiniteScrollSelect from '../../../components/InfiniteScrollSelect/InfiniteScrollSelect'
import { usersList, usersState } from '../../users/users.slice'
import EditReport from '../../reports/reportsTimeSheet/EditReport'

const { Option } = Select

const ReportFilters = ({ name }) => {
    const dispatch = useDispatch()

    const { pageLimit, currentPage, skipPage, isNext, projects, status } =
        useSelector(projectsState)
    const { tableData } = useSelector((state) => state.finalReportsSlice)
    const { reportDrawerFilterData } = useSelector((state) => state.finalReportsSlice)
    const { filter } = useSelector(projectReportsState)
    const [selectedUsers, setSelectedUsers] = useState([])
    const [isEditReport, setIsEditReport] = useState(false)



    const {
        teamList,
        teamListLoading,
        skipPage: teamSkipPage,
        currentPage: teamCurrentPage,
        pageLimit: teamPageLimit,
        isNext: teamIsNext,
    } = useSelector(teamState)

    const {
        users,
    } = useSelector(usersState)

    const [state, setState] = useState({
        filteredAssignees: [],
        filteredProjects: [],
        filteredUsers: [],
        selectAssignees: [],
        selectProjects: [],
    })
    const [searchValue, setSearchValue] = useState('')

    const selectedProjectId =
        tableData?.projectId?.[0]?.value ||
        tableData?.projectId?.[0] ||
        ''

    const userOptions = selectedProjectId
        ? state.filteredAssignees
        : state.filteredUsers

    useEffect(() => {
        dispatch(usersList({ limit: 100, skip: 0 }))
    }, [])


    useEffect(() => {
        if (state.selectAssignees.length == 0) {
            if (Array.isArray(teamList)) {
                const filterUsers = teamList.map(
                    ({ name, _id, profilePicture }) => ({
                        label: name,
                        value: _id,
                        profilePicture,
                    })
                )
                setState((prev) => ({
                    ...prev, selectAssignees
                        : filterUsers
                }))
            }
        }
    }, [teamList])

    useEffect(() => {
        if (Array.isArray(users)) {
            const allUsers = users.map(({ name, _id, profilePicture }) => ({
                label: name,
                value: _id,
                profilePicture,
            }))
            setState((prev) => ({ ...prev, filteredUsers: allUsers }))
        }
    }, [users])

    useEffect(() => {
        if (Array.isArray(teamList)) {
            const filterUsers = teamList.map(
                ({ name, _id, profilePicture }) => ({
                    label: name,
                    value: _id,
                    profilePicture,
                })
            )
            setState((prev) => ({ ...prev, filteredAssignees: filterUsers }))
        }
    }, [teamList])

    useEffect(() => {
        if (Array.isArray(projects)) {
            const newProjects = projects.map(
                ({ name, _id, projectProfile }) => ({
                    label: name,
                    value: _id,
                    projectProfile,
                })
            )
            setState((prev) => ({
                ...prev,
                filteredProjects: [...prev.filteredProjects, ...newProjects],
            }))
        }
    }, [projects])

    const fetchMoreProjects = (page, searchText = '') => {
        const nextSkip = (page - 1) * pageLimit
        dispatch(changeProjectPage({ currentPage: page, skip: nextSkip, pageLimit }))
        dispatch(projectsList({ limit: pageLimit, skip: nextSkip, search: searchText }))
    }

    const debouncedFetchProject = useCallback(
        debounce((value) => {
            dispatch(projectsList({ skip: 0, limit: pageLimit, search: value }))
        }, 600),
        [dispatch, pageLimit]
    )

    const debouncedFetchUser = useCallback(
        debounce((value, projectId) => {
            if (projectId) {

                dispatch(
                    teamListGet({
                        skip: 0,
                        limit: teamPageLimit,
                        search: value,
                        projectId,
                    })
                )
            } else {
                dispatch(usersList({ limit: 100, skip: 0, search: value, }))
            }
        }, 600),
        [dispatch, teamPageLimit]
    )

    const tagRender = ({ label, value, closable, onClose }) => {
        const user = userOptions.find((u) => u.value === value)
        const initials = user?.label
            ?.split(' ')
            .map((n) => n[0]?.toUpperCase())
            .join('')

        return (
            <div style={styles.tag}>
                {user?.profilePicture ? (
                    <Avatar size={20} src={user.profilePicture} style={{ marginRight: 6 }} />
                ) : (
                    <Avatar size={20} style={styles.avatarFallback}>
                        {initials}
                    </Avatar>
                )}
                <span style={styles.label}>{user?.label}</span>
                {closable && (
                    <span
                        onClick={onClose}
                        style={{ cursor: 'pointer', display: 'flex', marginLeft: "4px" }}
                    >
                        <CrossIcon width={8} color={'#252525'} />
                    </span>
                )}
            </div>
        )
    }

    return (
        <>

            <Row
                align="middle"
                justify="space-between"
                style={{ flexFlow: 'nowrap' }}
            >
                <Row
                    align="middle"
                    style={{ columnGap: '20px', flexFlow: 'nowrap', width: '100%' }}
                >
                    <InfiniteScrollSelect
                        style={{ minWidth: '250px' }}
                        value={
                            tableData?.projectId?.length > 0
                                ? tableData.projectId[0]
                                : undefined
                        }
                        onChange={(selected) => {
                            setSelectedUsers([])
                            dispatch(setTableData({ ...tableData, projectId: [selected], page: 0 }))
                            // dispatch(getAllUserReportList({
                            //     ...tableData,
                            //     projectId: selected ? [selected?.value] : [],
                            // }))
                            const updatedFilter = {
                                ...reportDrawerFilterData,
                                projectId: selected,
                            }

                            dispatch(setDrawerFilter(updatedFilter))
                            if (selected) {
                                setState((prevState) => ({
                                    ...prevState,
                                    selectProjects: selected,
                                    selectAssignees: []
                                    // filteredAssignees: [],
                                }))

                                dispatch(teamListGet({
                                    skip: 0,
                                    limit: teamPageLimit,
                                    search: '',
                                    projectId: selected ? selected?.value : '',
                                }))
                            }
                        }}
                        onOpen={() => debouncedFetchProject('')}
                        placeholder="Select a Project"
                        data={state.filteredProjects}
                        isNext={isNext}
                        loading={status === 'loading'}
                        currentPage={currentPage}
                        search={searchValue}
                        fetchMore={fetchMoreProjects}
                        onSearch={(val) => {
                            setSearchValue(val)
                            debouncedFetchProject(val)
                        }}
                        renderOption={({ projectProfile, label }) => (
                            <Space>
                                {projectProfile ? (
                                    <Image
                                        src={projectProfile}
                                        width={24}
                                        height={24}
                                        preview={false}
                                        style={{ borderRadius: '50%' }}
                                    />
                                ) : (
                                    <Avatar size={24}>{label?.[0]}</Avatar>
                                )}
                                <span>{label}</span>
                            </Space>
                        )}
                    />

                    <Select

                        showSearch
                        size="small"
                        mode="multiple"
                        placeholder="Select a User"
                        className="reports_user_selecter reports_user_selecter"
                        rootClassName="p-0-multiSelect"
                        tagRender={tagRender}
                        // filterOption={(input, option) =>
                        //     option?.key
                        //         ?.toLowerCase()
                        //         .includes(
                        //             input.toLowerCase()
                        //         )
                        // }
                        filterOption={false}
                        onSearch={(val) => debouncedFetchUser(val, selectedProjectId)}
                        onChange={(selected) => {
                            setSelectedUsers(selected) // update state
                            dispatch(setTableData({ ...tableData, userId: selected, page: 0 }))
                            setState((prevState) => ({
                                ...prevState,
                                selectAssignees: userOptions.filter((user) =>
                                    selected.includes(user.value)
                                ),
                            }))
                            // dispatch(
                            //     getAllUserReportList({
                            //         ...tableData,
                            //         assigneeId: selected,
                            //         projectId: selectedProjectId ? [selectedProjectId] : [],
                            //     })
                            // )
                        }}
                        value={selectedUsers}
                        style={{ width: '100%', borderRadius: '8px' }}
                        notFoundContent={
                            teamListLoading || status === 'loading' ? (
                                <Spin size="small" />
                            ) : userOptions.length === 0 ? (
                                'No User found'
                            ) : null
                        }
                    >
                        {userOptions.map(({ value, label, profilePicture }) => (
                            <Option value={value} key={value}>
                                <Row align="middle" style={{ columnGap: '10px' }}>
                                    {profilePicture ? (
                                        <Image
                                            src={profilePicture}
                                            width={25}
                                            height={25}
                                            style={{
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                minWidth: '25px',
                                            }}
                                            preview={false}
                                        />
                                    ) : (
                                        <Avatar style={styles.avatarFallback}>
                                            {label?.split(' ').map((n) => n[0]).join('')}
                                        </Avatar>
                                    )}
                                    {label}
                                </Row>
                            </Option>
                        ))}
                    </Select>

                </Row>

                <DateFilter
                    props={{
                        dateRangesList,
                        name,
                        selectedProject: state.selectProjects,
                        selectAssignees: state.selectAssignees,
                        filteredProjects: state.filteredProjects,
                        setIsEditReport,
                    }}
                />
            </Row>
            <EditReport
                isEditReport={isEditReport}
                setIsEditReport={setIsEditReport}
            />
        </>
    )
}

const styles = {
    tag: {
        display: 'flex',
        alignItems: 'center',
        background: '#f5f5f5',
        borderRadius: 10,
        padding: '4px 8px 4px 4px',
        margin: '4px 2px',
        maxWidth: '100%',
        border: '1px solid #afafaf80',
    },
    avatarFallback: {
        backgroundColor: 'rgb(0 10 129 / 25%)',
        color: '#000',
        fontSize: 9,
        marginRight: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
    },
    label: {
        fontSize: 12,
        fontWeight: 500,
        color: '#333',
        marginRight: 4,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 100,
    },
}

export default ReportFilters
